// extracted by mini-css-extract-plugin
export default {"form-inputs":"Form_form-inputs__FO45d","form__actions":"Form_form__actions__R8trT","form__actions__cancel-btn":"Form_form__actions__cancel-btn__dgfTh"};